import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../../../../shared/environment.service';

@Injectable({
  providedIn: 'root',
})
export class OrganizationService {
  baseUrl = `${this.env.apiUrl}/organisations`;
  headers = this.env.getCommonHeaders();
  constructor(public http: HttpClient, public env: EnvironmentService) {}
  fetchOrganization() {
    let url = `organisations`;
    return this.env.get(url);
  }

  updateOrganization(params: FormData) {
    let url = 'organisations';
    return this.env.putFormData(url, params);
  }

  getMemberTypes(orgId: any, params?:any){
    let urlParams=''
    for (const key in params) {
      if (
        params.hasOwnProperty(key) &&
        params[key] !== undefined &&
        params[key] !== ''
      ) {
        if (urlParams === '') {
          urlParams += `?${key}=${params[key]}`;
        } else {
          urlParams += `&${key}=${params[key]}`;
        }
      }
    }
    let url = `member-types/ordered/organisation/${orgId}${urlParams}`;
    return this.env.get(url);
  }
  deleteOrganisationImage(orgId: any){   //for deleting organisation Logo 
    let url = `organisations/image/remove?organisationId=${orgId}`;
    return this.env.patch(url);
  }
  uploadOrganizationLogo(params:any,orgId:any){   //for updating organisation Logo
    let url = `organisations/image?organisationId=${orgId}`;
    return this.env.patchFormData(url,params);
  }

  fetchOrgDuty(orgId: any,params?:any) {
    let urlParams=''
    for (const key in params) {
      if (
        params.hasOwnProperty(key) &&
        params[key] !== undefined &&
        params[key] !== ''
      ) {
        if (urlParams === '') {
          urlParams += `?${key}=${params[key]}`;
        } else {
          urlParams += `&${key}=${params[key]}`;
        }
      }
    }
    let url = params ? `duties/organisation/${orgId}${urlParams}` : `duties/organisation/${orgId}`;
    return this.env.get(url);
  }
}
